import { useState } from 'react';
import ScreenContainer from '../../components/ScreenContainer';
import Header from '../../components/Header';
import Button from '../../components/Button';
import { typography } from '../../styles/typography';
import colors from '../../styles/colors';
import Footer from '../../components/Footer';
import DropDown from '../../icons/DropDown';
import VideoCam from '../../icons/VideoCam';
import Camera from '../../icons/Camera';
import Check from '../../icons/Check';
import CancelRound from '../../icons/CancelRound';
import Play from '../../icons/Play';
import { t } from 'i18next'

export default function CS() {

  return (
    <ScreenContainer style={style.container}>
      <Header />
      <div className={"scrollContainer"} style={style.scrollContainer}>
        <div style={style.title} className='mt-24'>{t('cs_235')}</div>
        <div style={style.subtitle}>{}</div>
      </div>
    </ScreenContainer>

  );
}

const style = {
  container: {
    maxHeight: '100vh',
    overflow: 'hidden',
  },
  scrollContainer: {
    alignItems: 'flex-start',
    overflowY: 'scroll',
    flex: 1
  },
  title: {
    ...typography.title.m_24_medium,
    color: colors.white
  },
  
}